const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token, options = {}) => {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(`${API}${path}`, {
      credentials: "include",
      headers: {
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      ...options,
      signal: controller.signal,
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(body.detail || `Request failed: ${response.status}`);
      error.status = response.status;
      throw error;
    }
    return body;
  } catch (error) {
    if (error?.name === "AbortError") {
      const timeoutError = new Error("Strong Auth braucht gerade zu lange. Bitte versuche es erneut.");
      timeoutError.status = 408;
      throw timeoutError;
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
};

export const getStrongAuthStatus = async (token) => request("/trust/strong-auth/status", token);

export const startTotpEnrollment = async (password, token) => request("/trust/strong-auth/totp/enroll/start", token, {
  method: "POST",
  body: JSON.stringify({ password }),
});

export const confirmTotpEnrollment = async (code, token) => request("/trust/strong-auth/totp/enroll/confirm", token, {
  method: "POST",
  body: JSON.stringify({ code }),
});

export const verifyTotpStepUp = async (code, token) => request("/trust/strong-auth/totp/verify", token, {
  method: "POST",
  body: JSON.stringify({ code }),
});

export const disableTotp = async (password, code, token) => request("/trust/strong-auth/totp/disable", token, {
  method: "POST",
  body: JSON.stringify({ password, code }),
});


export const verifyRecoveryCodeStepUp = async (code, token) => request("/trust/strong-auth/recovery/verify", token, {
  method: "POST",
  body: JSON.stringify({ code }),
});

export const regenerateRecoveryCodes = async (password, code, token) => request("/trust/strong-auth/recovery/regenerate", token, {
  method: "POST",
  body: JSON.stringify({ password, code }),
});
